import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_quote,
  get_quote,
  update_quote,
} from "../../../../Controllers/Sales/Quotes";
import forms from "../../../../Data/Forms/Sales/Quotes/forms";
import headers from "../../../../Data/Forms/Sales/Quotes/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Quotetable from "../../../../Data/Forms/Sales/Quotes/table";

const QuotesForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const [details, setDetails] = useState([
    {
      id: "",
      description: null,
      unit: "",
      purchase_price: "",
      quantity: "",
      delivered: "",
      discount: "",
      delivery: "",
      tax: 0,
      total: 0,
    },
  ]);
  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    delivery: 0,
    delivery_status: 0,
    delivery_date: "",
    payment_status: 0,
    payment_types: null,
    payments: {
      Cash: "",
      Cheque: "",
      "Debit card": "",
      "Credit card": "",
      "Bank transfer": "",
      "Online payment": "",
    },
    paid: 0,
    remaining: 0,
    total: "0.000",
  });

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const quote = id
        ? await update_quote({
            ...data?.data,
            id: id,
            details: details,
            subtotal: totals?.subtotal,
            taxamount: totals?.taxamount,
            discount: totals?.discount,
            delivery: totals?.delivery,
            delivery_status: totals?.delivery_status,
            delivery_date: totals?.delivery_date,
            payment_status: totals?.payment_status,
            payment_types: totals?.payment_types,
            payments: totals?.payments,
            total: totals?.total,
          })
        : await create_quote({
            ...data?.data,
            details: details,
            subtotal: totals?.subtotal,
            taxamount: totals?.taxamount,
            discount: totals?.discount,
            delivery: totals?.delivery,
            delivery_status: totals?.delivery_status,
            delivery_date: totals?.delivery_date,
            payment_status: totals?.payment_status,
            payment_types: totals?.payment_types,
            payments: totals?.payments,
            total: totals?.total,
          });

      if (quote?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(quote?.message);
        setButtonLoader(false);
      } else {
        toast?.error(quote?.message);
        setButtonLoader(false);
      }
    }
  };

  const handleData = (quote) => {
    let customer = quote?.customer?._id ? quote?.customer?._id : null;
    let number = quote?.number ? quote?.number : "";
    let date = quote?.date ? quote?.date : "";
    let due_date = quote?.due_date ? quote?.due_date : "";
    let status = quote?.status ? quote?.status : 0;

    let customer_option = quote?.customer?._id
      ? [
          {
            value: quote?.customer?._id,
            label: quote?.customer?.name,
          },
        ]
      : null;

    values[0].options[0].form.value = customer;
    values[0].options[0].form.options = customer_option;
    values[0].options[1].form.value = number;
    values[0].options[2].form.value = date;
    values[0].options[3].form.value = due_date;
    values[0].options[4].form.value = status;

    let data = [];
    quote?.details?.map((value, index) => {
      data?.push({
        id: value?._id,
        description: JSON?.stringify(value?.description),
        options: [
          {
            value: JSON?.stringify(value?.description),
            label: value?.description?.name,
          },
        ],
        unit: value?.unit,
        purchase_price: value?.purchase_price,
        quantity: value?.quantity,
        delivered: value?.delivered,
        discount: value?.discount,
        delivery: value?.delivery,
        tax: value?.tax,
        total: value?.total,
      });
    });

    totals.subtotal = quote?.subtotal;
    totals.taxamount = quote?.taxamount;
    totals.discount = quote?.discount;
    totals.delivery = quote?.delivery;
    totals.delivery_status = quote?.delivery_status;
    totals.delivery_date = quote?.delivery_date;
    totals.payment_status = quote?.payment_status;
    totals.payment_types = JSON?.parse(quote?.payment_types);
    totals.payments = JSON?.parse(quote?.payments);
    totals.paid = quote?.paid;
    totals.remaining = quote?.remaining;
    totals.total = quote?.total;

    setValues([...values]);
    setDetails([...data]);
    setTotals({ ...totals });
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const quote = await get_quote(data);
      if (quote?.status) {
        handleData(quote?.data);
      } else {
        toast?.error(quote?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Quotetable
                details={details}
                setDetails={setDetails}
                totals={totals}
                setTotals={setTotals}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default QuotesForm;
